"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _store = require("@/api/store");
var _index2 = _interopRequireDefault(require("@/components/pagesHeader/index.vue"));
var _vuex = require("vuex");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  components: {
    pagesHeader: _index2.default
  },
  name: 'addAtmosphere',
  directives: {
    // 计算是否滚动到最下面
    selectLoadMore: {
      bind: function bind(el, binding) {
        // 获取element-ui定义好的scroll盒子
        var SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          if (this.scrollHeight - this.scrollTop < this.clientHeight + 1) {
            binding.value();
          }
        }, {
          passive: true
        });
      }
    }
  },
  data: function data() {
    return {
      multiple: true,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > Date.now() + 600 * 8.64e7; //限制未来时间
        }
      },
      props: {
        value: 'id',
        label: 'name',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: false,
        multiple: true,
        emitPath: false
      },
      currentTab: '1',
      tabList: [{
        value: '1',
        title: '基础设置'
      }, {
        value: '2',
        title: '使用范围'
      }],
      fullscreenLoading: false,
      formValidate: {
        name: '',
        starttime: '',
        endtime: '',
        style: '',
        status: 0,
        method: 0,
        products: null,
        proCategorylist: [],
        type: null,
        timeVal: [],
        id: null
      },
      ruleValidate: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        style: [{
          required: true,
          message: '请选择图片',
          trigger: 'blur'
        }],
        proCategorylist: [{
          type: 'array',
          required: true,
          message: '请至少选择一个分类',
          trigger: 'change'
        }],
        timeVal: [{
          type: 'array',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }]
      },
      listLoading: false,
      selectGoods: false,
      multipleSelection: [],
      merSelect: [],
      tableData: {
        data: [],
        total: 0
      },
      options: [{
        value: 'all',
        label: '所有页'
      }, {
        value: 'one',
        label: '当前页'
      }],
      tableFrom: {
        page: 1,
        limit: 20,
        spu_ids: []
      },
      ids: [],
      search: {
        limit: 10,
        page: 1
      },
      brandList: [],
      loading: false,
      tempRoute: {}
    };
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['adminProductClassify'])), {}, {
    isEdit: function isEdit() {
      return this.$route.params.id ? true : false;
    },
    activityTpye: function activityTpye() {
      return this.$route.path.indexOf('border') !== -1 ? 0 : 1;
    }
  }),
  mounted: function mounted() {
    if (!localStorage.getItem('adminProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if (this.$route.params.id) {
      this.setTagsViewTitle();
      this.getInfo(this.$route.params.id);
    }
  },
  methods: {
    // 点击选项
    onChangeType: function onChangeType(formName) {
      //this.$refs[formName].resetFields();
    },
    // 根据id查询商品列表，编辑时用
    getproductListbyids: function getproductListbyids() {
      var _this2 = this;
      (0, _store.productListbyidsApi)(this.formValidate.products).then(function (res) {
        _this2.tableData.data = res.list;
      });
    },
    // 活动时间
    onchangeTime: function onchangeTime(e) {
      this.$set(this.formValidate, 'timeVal', e);
      this.formValidate.starttime = e ? e[0] : '';
      this.formValidate.endtime = e ? e[1] : '';
    },
    //上传图片
    modalPicTap: function modalPicTap(multiple) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        _this.formValidate.style = img[0].sattDir;
        if (_this.formValidate.style) _this.$refs.formValidate.clearValidate(['style']);
      }, multiple, 'activitystyle');
    },
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.activityTpye === 1 ? '编辑氛围图' : '编辑活动边框';
      var route = Object.assign({}, this.tempRoute, {
        title: "".concat(title, "-").concat(this.$route.params.id)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 氛围图详情
    getInfo: function getInfo(id) {
      this.fullscreenLoading = true;
      var data = JSON.parse(localStorage.getItem('activitystyle'));
      var info = JSON.parse(JSON.stringify(data));
      this.formValidate.starttime = info.starttime;
      this.formValidate.endtime = info.endtime;
      this.formValidate.style = info.style;
      this.formValidate.status = info.status;
      this.formValidate.method = info.method;
      this.formValidate.name = info.name;
      this.formValidate.products = info.products;
      this.formValidate.type = this.activityTpye;
      this.formValidate.timeVal = [info.starttime, info.endtime];
      if (info.method === 1) this.getproductListbyids();
      switch (info.method) {
        case 0:
          this.formValidate.products = '';
          break;
        case 1:
          this.formValidate.products = '';
          break;
        case 2:
          break;
        case 3:
          this.formValidate.proCategorylist = info.products.split(',').map(function (item) {
            return item * 1;
          });
          break;
        default:
          break;
      }
      this.fullscreenLoading = false;
      this.fullscreenLoading = false;
    },
    addGoods: function addGoods() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.listLoading = false;
        _this.tableData.data = row;
      }, 'many', _this.tableData.data);
    },
    getList: function getList(num) {
      var _this3 = this;
      this.tableFrom.page = num || this.tableFrom.page;
      (0, _marketing.selectProductList)({
        spu_ids: this.tableFrom.spu_ids.toString(),
        page: this.tableFrom.page,
        limit: this.tableFrom.limit
      }).then(function (res) {
        _this3.tableData.data = res.data.list;
        _this3.tableData.total = res.data.count;
        if (_this3.selectAllPage == 'all') {
          var _this3$multipleSelect;
          (_this3$multipleSelect = _this3.multipleSelection).push.apply(_this3$multipleSelect, _toConsumableArray(_this3.tableData.data));
          _this3.multipleSelection.forEach(function (row) {
            _this3.$refs.tableList.toggleRowSelection(row, true);
          });
        }
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.$message.error(res.message);
        _this3.listLoading = false;
      });
    },
    //行删除
    handleDelete: function handleDelete(index, row) {
      var _this4 = this;
      this.$modalSure('删除该商品吗？').then(function () {
        _this4.tableData.data.splice(index, 1);
      });
    },
    //批量删除
    batchDel: function batchDel() {
      var _this5 = this;
      this.$modalSure('批量删除商品吗？').then(function () {
        var data = [];
        var _iterator = _createForOfIteratorHelper(_this5.tableData.data),
          _step;
        try {
          var _loop = function _loop() {
            var item1 = _step.value;
            var _index = _this5.multipleSelection.findIndex(function (c) {
              return c.id === item1.id;
            });
            if (_index === -1) {
              data.push(item1);
            }
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this5.tableData.data = data;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectAll: function selectAll(data) {
      var id = data.map(function (i, index) {
        return i.spu_id;
      });
      this.ids = Array.from(new Set([].concat(_toConsumableArray(this.ids), _toConsumableArray(id))));
    },
    selectOne: function selectOne(data, row) {
      var id = data.map(function (i, index) {
        return i.spu_id;
      });
      var index = this.ids.findIndex(function (e) {
        return e == row.spu_id;
      });
      this.ids.splice(index, 1);
      this.ids = Array.from(new Set([].concat(_toConsumableArray(this.ids), _toConsumableArray(id))));
    },
    handleCommand: function handleCommand(command) {
      var _this6 = this;
      this.$message('click on item ' + command);
      this.selectAllPage = command === 'all';
      this.$nextTick(function () {
        _this6.$refs.tableList.toggleAllSelection();
      });
    },
    submitForm: function submitForm(formName, num) {
      var _this7 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (num === 1) {
            _this7.currentTab = '2';
          } else {
            switch (_this7.formValidate.method) {
              case 0:
                _this7.formValidate.products = '';
                break;
              case 1:
                if (!_this7.tableData.data.length) return _this7.$message.error('请选择至少一个商品');
                var data = [];
                _this7.tableData.data.map(function (item) {
                  return data.push(item.id);
                });
                _this7.formValidate.products = data.toString();
                break;
              case 2:
                break;
              case 3:
                if (!_this7.formValidate.proCategorylist.length) return _this7.$message.error('请选择至少一个分类');
                _this7.formValidate.products = _this7.formValidate.proCategorylist.toString();
                break;
              default:
                break;
            }
            _this7.formValidate.type = _this7.activityTpye;
            if (_this7.formValidate.style == '') return _this7.$message.error('请上传氛围图');
            if (_this7.isEdit) _this7.formValidate.id = _this7.$route.params.id;
            _this7.isEdit ? (0, _marketing.atuosphereUpdateApi)(_this7.formValidate).then(function (res) {
              _this7.$message.success('编辑成功');
              _this7.$router.push({
                path: _this7.activityTpye === 1 ? '/marketing/atmosphere/list' : '/marketing/border/list'
              });
            }) : (0, _marketing.createAtuosphere)(_this7.formValidate).then(function (res) {
              _this7.$message.success('新增成功');
              _this7.$router.push({
                path: _this7.activityTpye === 1 ? '/marketing/atmosphere/list' : '/marketing/border/list'
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    }
  }
};